function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVSwitchOutputNew({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 31.29 25.04",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m0,6.26c0-.87.7-1.56,1.56-1.56h15c-.67-.67-1.35-1.35-2.02-2.02-.61-.61-.61-1.6,0-2.21s1.6-.61,2.21,0c1.56,1.56,3.13,3.13,4.69,4.69.61.61.61,1.6,0,2.22l-4.69,4.69c-.61.61-1.6.61-2.21,0s-.61-1.6,0-2.21c.67-.67,1.35-1.35,2.02-2.02H1.56c-.87,0-1.56-.7-1.56-1.56Zm.46,11.41l4.69-4.69c.61-.61,1.6-.61,2.21,0s.61,1.6,0,2.21c-.67.67-1.35,1.35-2.02,2.02h10.34c-.02.26-.03.52-.03.78,0,.81.11,1.6.32,2.35H5.34c.67.67,1.34,1.34,2.02,2.02.61.61.61,1.6,0,2.21-.61.61-1.6.61-2.21,0L.46,19.88c-.61-.61-.61-1.6,0-2.21Zm16.75.33c0-3.89,3.15-7.04,7.04-7.04s7.04,3.15,7.04,7.04-3.15,7.04-7.04,7.04-7.04-3.15-7.04-7.04Zm5.48,0c0,.43.35.78.78.78v2.35c-.43,0-.78.35-.78.78s.35.78.78.78h1.56c.43,0,.78-.35.78-.78s-.35-.78-.78-.78v-3.13c0-.43-.35-.78-.78-.78h-.78c-.43,0-.78.35-.78.78Zm.39-3.52c0,.65.52,1.17,1.17,1.17s1.17-.52,1.17-1.17-.52-1.17-1.17-1.17-1.17.52-1.17,1.17Z",
    style: {
      fill: "#4d9cd3",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVSwitchOutputNew);
export default __webpack_public_path__ + "static/media/vSwitch-Output-new.38a229c610c24032857911e0e36cffca.svg";
export { ForwardRef as ReactComponent };